<mat-card appearance="outlined" class="flat mt-10" style="margin-bottom: 10px">
  <div class="row" [formGroup]="messageForm">
    <div class="col-xs-6">
      <div [id]="identifierService.labelId('direct-call-messaging', 'directMsgng')"
        class="merlin-header"
        style="margin-bottom: 10px"
        [innerHtml]="labels['label.gb.direct_msgng']"
        data-tx-key="label.gb.direct_msgng">
        <!-- {{ 'label.gb.direct_msgng'] }} -->
      </div>
      <p [id]="identifierService.labelId('direct-call-messaging', 'getPermission')" [innerHtml]="labels['label.gb.get_permission']" data-tx-key="label.gb.get_permission"></p>

      <div class="check-styl">
        <mat-checkbox [id]="identifierService.checkboxId('direct-call-messaging', 'msgReminderFlg')"
          color="primary"
          formControlName="msgReminderFlg"
          (change)="onCheckboxChangeMsgReminder($event)"
          ><span [id]="identifierService.labelId('direct-call-messaging', 'autoFollowupReminders')"
                        [innerHtml]="
                            labels['label.gb.auto_followup_reminders']
                        "
          data-tx-key="label.gb.auto_followup_reminders"></span
        ></mat-checkbox>
      </div>
      <div class="check-styl">
        <mat-checkbox [id]="identifierService.checkboxId('direct-call-messaging', 'msgOverdueFlg')"
          color="primary"
          formControlName="msgOverdueFlg"
          [disabled]="disableDirectCallBox()"
          (change)="onCheckboxChangeMsgOverdue($event)"
          ><span [id]="identifierService.labelId('direct-call-messaging', 'autoOverdueMsg')"
          [innerHtml]="labels['label.gb.auto_overdue_msg']"
          data-tx-key="label.gb.auto_overdue_msg"></span
        ></mat-checkbox>
      </div>
      <br />
      @if (displayEditUI()) {
        <div class="row" style="margin-top: 10px">
          <div class="col-xs-3 dcFields">
            <merlin-textbox
              [groupName]="messageForm"
              label="{{ labels['label.gb.between'] }}"
              [required]="true"
              controlName="msgStartTime"
              maxLength="50"
              [id]="identifierService.dropdownId('direct-call-messaging','msgStartTime')"
              data-tx-key="label.gb.between"></merlin-textbox>
          </div>
          @if (timeFormatFlag) {
            <div class="col-xs-3 dcFields">
              <mat-form-field class="merlin-select full-width" appearance="outline" floatLabel="always">
                <mat-label [id]="identifierService.labelId('directCallMsg', 'startAmpm')" data-tx-key="label.gb.am">{{ labels['label.gb.am'] }}/{{ labels['label.gb.pm'] }}</mat-label>
                <mat-select formControlName="msgStartAmpm" [disableOptionCentering]="true" [id]="identifierService.dropdownId('direct-call-messaging','msgStartAmpm')" data-tx-key="label.gb.drctcall_mthd">
                  @for (a of dropDownsList.ampm; track a) {
                    <mat-option [id]="identifierService.listitemId('direct-call-messaging', 'startAmpmOption_' + a?.value)" value="{{ a.value }}">{{ labels[a.label] }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-xs-3 dcFields">
            <merlin-textbox
              [groupName]="messageForm"
              label="{{ labels['label.gb.and'] }}"
              [required]="true"
              controlName="msgEndTime"
              maxLength="50"
              [id]="identifierService.dropdownId('direct-call-messaging','msgEndTime')"
              data-tx-key="label.gb.and"></merlin-textbox>
          </div>
          @if (timeFormatFlag) {
            <div class="col-xs-3 dcFields">
              <mat-form-field class="merlin-select full-width" appearance="outline" floatLabel="always">
                <mat-label [id]="identifierService.labelId('directCallMsg', 'endAmpm')" data-tx-key="label.gb.pm">{{ labels['label.gb.am'] }}/{{ labels['label.gb.pm'] }}</mat-label>
                <mat-select formControlName="msgEndAmpm" [disableOptionCentering]="true" [id]="identifierService.dropdownId('direct-call-messaging','msgEndAmpm')">
                  @for (a of dropDownsList.ampm; track a) {
                    <mat-option [id]="identifierService.listitemId('direct-call-messaging', 'endAmpmOption_' + a?.value)" value="{{ a.value }}" data-tx-key="a.label">{{ labels[a.label] }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
        </div>
        <div class="row">
          <div class="col-xs-6 dcMethod">
            <mat-form-field class="merlin-select full-width" appearance="outline" floatLabel="always">
              <mat-label [id]="identifierService.labelId('directCallMsg', 'drctcallMthd')" [innerHtml]="labels['label.gb.drctcall_mthd']" data-tx-key="label.gb.drctcall_mthd"></mat-label>
              <mat-select formControlName="callContactTypeCd" [disableOptionCentering]="true" [compareWith]="compareCodes" [id]="identifierService.dropdownId('direct-call-messaging','callContactTypeCd')" (selectionChange)="onCallmedicalSelOption()">
                @for (alert of contactAlertList; track alert) {
                  <mat-option [id]="identifierService.listitemId('direct-call-messaging', 'contactAlertOption_' + alert?.codeId)" [value]="alert.codeId" data-tx-key="contactTypeCode[alert.code]">{{ labels[contactTypeCode[alert.code]] }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
      @if (primaryMobile && !showMedicalSelOption) {
        <div class="row stdRates">
          <div [id]="identifierService.labelId('direct-call-messaging', 'stdRatesApply_pri_mob')" class="col-xs-12" data-tx-key="label.gb.std_rates_apply" [innerHTML]="labels['label.gb.std_rates_apply'] | safe: 'html'"></div>
        </div>
      }
      @if (showMedicalSelOption) {
        <div class="row">
          <div class="col-xs-6 dcMethod sms-input">
            <merlin-textbox [required]="isOtherPhone" maxLength="30" [groupName]="messageForm" label="{{ labels['label.gb.other_phone'] }}" placeHolder="{{ labels['label.gb.other_phone'] }}" controlName="patientCallSMS" [id]="identifierService.dropdownId('direct-call-messaging','patientCallSMS')" data-tx-key="label.gb.other_phone"></merlin-textbox>
          </div>
          <div class="sms-icon">
            <img src="assets/images/question.png" alt="info" [mdePopoverTriggerFor]="dataRatesPopover" />
            <mde-popover #dataRatesPopover="mdePopover" [mdePopoverOverlapTrigger]="false" mdePopoverPositionX="after" mdePopoverPositionY="above" [mdePopoverArrowOffsetX]="15" [id]="identifierService.dropdownId('direct-call-messaging','msgInfo')">
              <mat-card appearance="outlined" style="max-width: 300px">
                <mat-card-content>
                  <div [id]="identifierService.labelId('direct-call-messaging', 'textMsgInfo')" [innerHTML]="labels['label.gb.text_msg_info'] | safe: 'html'"></div>
                </mat-card-content>
              </mat-card>
            </mde-popover>
          </div>
          <div [id]="identifierService.labelId('direct-call-messaging', 'stdRatesApply')" class="col-xs-12" data-tx-key="label.gb.std_rates_apply" [innerHTML]="labels['label.gb.std_rates_apply'] | safe: 'html'"></div>
        </div>
      }
    </div>
    <div class="col-xs-6">
      <div>
        <h3 [id]="identifierService.labelId('directCallMessaging', 'medicalTeam')" class="merlin-header" data-tx-key="label.rpt.medical_team">{{ labels['label.rpt.medical_team'] }}</h3>
      </div>
      <p [id]="identifierService.labelId('direct-call-messaging', 'medTeamAfterHours')" data-tx-key="label.gb.place_med_team_after_hours_notif_order_blue" [innerHTML]="labels['label.gb.place_med_team_after_hours_notif_order_blue'] | safe: 'html'">
      </p>
      @if (displayEditUI()) {
        <app-figma-bucketlist
          [topList]="availablePhysList"
          [botList]="assignedPhysList"
          [enableNumbering]="true"
          [implantselectedItem]="implantselectedItem"
          (botSelectedItem)="botSelectedItem($event)"
          (botBoxUpdate)="botSelectBoxUpdate($event)"
          (avaliableIds)="botAvaliableIds($event)"
        ></app-figma-bucketlist>
        @if (!isLPCategory && !isICMCategory) {
          <div
            class="row"
            style="margin-top: 5px"
            >
            <div class="col-xs-12">
              <div
                class="mark-implanting-text-box"
                [class.mark-implanting-disabled]="!isMarkImplantingActive"
                (click)="isMarkImplantingActive && markImplantingPhysician(); updateMarkImplantingState()"
                        [id]="
                            identifierService.dropdownId(
                                'direct-call-messaging',
                                'markImplanting'
                            )
                        "
                    >
                        <mat-icon aria-hidden="false">
                            done
                        </mat-icon>
                        <div [id]="identifierService.labelId('directCallMessaging', 'markImplanting')" class="mark-implanting-text-box-text" data-tx-key="label.gb.mark_implanting">
                            {{ labels['label.gb.mark_implanting'] }}
                        </div>
                    </div>
                </div>
            </div>
        }
      }
    </div>
  </div>
</mat-card>
